import type { PageQuery } from './SearchTable'

export function pageQueryParams(query: PageQuery): string {
  return new URLSearchParams({
    pageNumber: String(query.pageNumber),
    pageSize: String(query.pageSize),
    search: query.search || '',
    sortBy: query.sortBy || '',
    sortDirection: query.sortDirection || '',
  }).toString();
}
